// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.clickable-rows[data-v-1b27d31a] tbody tr { cursor: pointer;\n}\n.tile[data-v-1b27d31a] { cursor: pointer; -webkit-transition: border-color 0.15s, background-color 0.15s; transition: border-color 0.15s, background-color 0.15s;\n}\n.tile[data-v-1b27d31a]:hover { background-color: rgba(0, 0, 0, 0.03);\n}\n.tile.on[data-v-1b27d31a] { border-color: var(--v-primary-base); border-width: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
